import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const usePhotos = () =>
  store(
    useShallow((state) => ({
      data: state.data,
      _ids: state._ids,
      count: state.count,
      loading: state.loading,
      loadingSpinner: state.loadingSpinner,
      error: state.error,
      params: state.params,
      fetchPhotos: state.fetchPhotos,
      init: state.init,
      updateFilters: state.updateFilters,
      updatePagination: state.updatePagination,
      updateSort: state.updateSort,
      resetFilters: state.resetFilters,
      hasActiveFilters: state.hasActiveFilters,
      moderatePhoto: state.moderatePhoto,
      moderatePhotos: state.moderatePhotos,
      updatePhoto: state.updatePhoto,
      setPhoto: state.setPhoto,
      reset: state.reset,
    })),
  );
